import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["preview", "full", "button"]

  toggle() {
    this.fullTarget.classList.toggle("hidden")
    this.previewTarget.classList.toggle("hidden")

    const isExpanded = !this.fullTarget.classList.contains("hidden")
    this.buttonTarget.textContent = isExpanded ? "Show less" : "Show more"
  }
}
